"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
const nav_frontend_ikoner_assets_1 = __importDefault(require("nav-frontend-ikoner-assets"));
const nav_frontend_popover_1 = __importStar(require("nav-frontend-popover"));
require("nav-frontend-hjelpetekst-style");
class Hjelpetekst extends React.Component {
    constructor(props) {
        super(props);
        this.knappRef = React.createRef();
        this.handleKeydown = (e) => {
            if (!this.state.ankerEl)
                return;
            if (e.keyCode === nav_frontend_js_utils_1.keyCodes.esc)
                this.knappRef.current.focus();
        };
        this.togglePopover = (e) => {
            if (e && !this.state.ankerEl) {
                this.setState({ ankerEl: e.currentTarget });
            }
            else {
                this.setState({ ankerEl: undefined });
            }
        };
        this.handleClick = (e) => {
            this.togglePopover(e);
            this.props.onClick && this.props.onClick(e);
        };
        this.state = {
            ankerEl: undefined,
        };
        this.popoverId = (0, nav_frontend_js_utils_1.guid)();
    }
    componentDidMount() {
        window.addEventListener("keydown", this.handleKeydown);
    }
    componentWillUnmount() {
        window.removeEventListener("keydown", this.handleKeydown);
    }
    render() {
        const _a = this.props, { children, className, popoverProps, type, tittel, onClick } = _a, rest = __rest(_a, ["children", "className", "popoverProps", "type", "tittel", "onClick"]);
        return (React.createElement("div", { className: (0, classnames_1.default)("hjelpetekst", className) },
            React.createElement("button", Object.assign({ type: "button", className: "hjelpetekst__apneknapp", onClick: this.handleClick, title: tittel, "aria-expanded": this.state.ankerEl !== undefined, "aria-controls": this.popoverId, "aria-haspopup": "dialog", ref: this.knappRef }, rest),
                React.createElement(nav_frontend_ikoner_assets_1.default, { kind: "help-circle", className: "hjelpetekst__ikon" }),
                React.createElement("span", { className: "sr-only" }, tittel)),
            React.createElement(nav_frontend_popover_1.default, Object.assign({ id: this.popoverId, ankerEl: this.state.ankerEl, onRequestClose: this.togglePopover, orientering: type, role: "tooltip" }, popoverProps),
                React.createElement("div", { className: "hjelpetekst__innhold" }, this.props.children))));
    }
}
Hjelpetekst.defaultProps = {
    type: nav_frontend_popover_1.PopoverOrientering.Over,
    tittel: "Hjelp",
};
exports.default = Hjelpetekst;
